import get from 'lodash.get';

export const selectConfirmCustomersModalId = (state) => get(state, 'confirmCustomersModalId');
export const selectCombineCustomersModalId = (state) => get(state, 'combineCustomersModalId');
